import {Component, HostListener, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {NotificationsService} from './pages/shared/services/notifications.service';
import {TranslateService} from './pages/shared/services/translate.service';
import {RouteService} from './services/route.service';
import {ItemService} from './services/item.service';
import {composeMessage} from './pages/shared/consts/errors';
import {AuthService} from './services/auth.service';
import {SocketService} from './services/socket.service';

@Component({
    selector: 'ageops-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.styl']
})
export class AppComponent implements OnInit {
    title = 'aets';
    appLoading = true;

    constructor(private routeService: RouteService,
                private router: Router,
                private notificationsService: NotificationsService,
                private translate: TranslateService,
                private auth: AuthService,
                private socketService: SocketService,
                private itemService: ItemService) {
        this.routeService.setProperRoute();
        this.socketService.connect();
    }

    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (event.url === '') {
                    this.appLoading = true;
                } else if (event.url !== '' && !this.appLoading) {
                    this.notificationsService.startLoading();
                }
            } else if (event instanceof NavigationEnd) {

                this.itemService.detectItemSelection();

                this.appLoading = false;
                if (event.url === '') {
                    this.appLoading = false;
                } else if (event.url !== '' && !this.appLoading) {
                    this.notificationsService.dismissLoading();
                }
            }
        }, (error) => {
            console.error(error);
            this.notificationsService.error(composeMessage(error));
        });
    }
}
